import React from 'react';
import {
  BusinessUnitFilter,
  CompanySpendTierFilter,
  CompanyTypeFilter,
  IndustryFilter,
  MemberFilter,
  PracticeFilter,
  SingleSelectFilter,
} from '~/components';
import useFeatures from '~/hooks/useFeatures.js';
import FiltersGroup from './FiltersGroup';

function CompanyFiltersGroup({ filters, onChange }) {
  const features = useFeatures();

  return (
    <FiltersGroup
      label="Company Filters"
      filters={[
        filters.companyOwners,
        filters.companyIsActive,
        filters.companyIndustries,
        filters.companyPractices,
        filters.companyBusinessUnits,
        filters.companyTypes,
        filters.companySpendTiers,
      ]}>
      <MemberFilter
        name="companyOwners"
        placeholder="Company Relationship Owner"
        value={filters.companyOwners}
        onChange={({ target: { value } }) => onChange({ companyOwners: value })}
      />

      <SingleSelectFilter
        icon="filter"
        name="companyIsActive"
        placeholder="Status"
        options={[
          { id: 'true', name: 'Active' },
          { id: 'false', name: 'Inactive' },
        ]}
        value={filters.companyIsActive}
        renderValue={(value) => value.name}
        onChange={({ target: { value } }) => onChange({ companyIsActive: value })}
      />

      <IndustryFilter
        name="companyIndustries"
        placeholder="Company Industry"
        value={filters.companyIndustries}
        onChange={({ target: { value } }) => onChange({ companyIndustries: value })}
      />

      {features.practices && (
        <PracticeFilter
          name="companyPractices"
          placeholder="Company Practice"
          value={filters.companyPractices}
          onChange={({ target: { value } }) => onChange({ companyPractices: value })}
        />
      )}

      {features.businessUnits && (
        <BusinessUnitFilter
          name="companyBusinessUnits"
          placeholder="Company Business Unit"
          value={filters.companyBusinessUnits}
          onChange={({ target: { value } }) => onChange({ companyBusinessUnits: value })}
        />
      )}

      <CompanyTypeFilter
        name="companyTypes"
        value={filters.companyTypes}
        onChange={({ target: { value } }) => onChange({ companyTypes: value })}
      />

      <CompanySpendTierFilter
        name="companySpendTiers"
        value={filters.companySpendTiers}
        onChange={({ target: { value } }) => onChange({ companySpendTiers: value })}
      />
    </FiltersGroup>
  );
}

export default CompanyFiltersGroup;
